/**
 * 提示词更新服务
 * 用于处理提示词的更新、保存和状态变更
 */

import DB from './dbService';

/**
 * 更新提示词信息
 * @param {Object} updatedPrompt - 更新后的提示词对象
 * @param {Function} setPrompts - 用于更新状态的函数
 * @returns {Promise} 返回一个Promise，解析为更新结果
 */
export const updatePrompt = async (updatedPrompt, setPrompts) => {
  try {
    // 在状态中更新提示词
    if (typeof setPrompts === 'function') {
      setPrompts(prevPrompts => {
        return prevPrompts.map(prompt => {
          if (prompt.id === updatedPrompt.id) {
            return updatedPrompt;
          }
          return prompt;
        });
      });
    }
    
    // 更新数据库中的提示词
    await DB.updateItem(DB.STORES.PROMPTS, updatedPrompt);
    console.log(`提示词 ${updatedPrompt.id} 已更新`);
    return { success: true };
  } catch (error) {
    console.error('更新提示词失败:', error);
    return { 
      success: false, 
      error: error.message || '操作失败，请稍后重试' 
    };
  }
};

/**
 * 更新提示词的共享状态
 * @param {Object} prompt - 要更新的提示词对象
 * @param {boolean} isShared - 是否共享
 * @param {Function} setPrompts - 用于更新状态的函数
 * @returns {Promise} 返回一个Promise，解析为更新结果
 */
export const updatePromptSharing = async (prompt, isShared, setPrompts) => {
  try {
    const result = await DB.togglePromptSharing(prompt.id, isShared);
    
    if (result.success) {
      const updatedPrompt = {
        ...prompt,
        isShared: isShared,
        shareId: result.shareId
      };
      
      // 更新状态
      await updatePrompt(updatedPrompt, setPrompts);
      
      return { 
        success: true, 
        shareId: result.shareId,
        updatedPrompt
      };
    } else {
      return { success: false, error: '操作失败，请稍后重试' };
    }
  } catch (error) {
    console.error('更新提示词共享状态失败:', error);
    return { 
      success: false, 
      error: error.message || '操作失败，请稍后重试' 
    };
  }
};

const promptUpdateService = {
  updatePrompt,
  updatePromptSharing
};

export default promptUpdateService;
